


















import { Resource } from '@/store/modules/resource'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ChooseWebApp extends Vue {
  @Prop() webApps!: Resource[]

  async loadWebApp (app: Resource) {
    await this.$store.dispatch('setAppToken', app.appToken)
    this.$bvModal.show('web-app-modal')
  }
}
